export const IMAGE_HOST = "https://cdn.bvote.vn";

export const MAX_PRICE = 50000000;

export const COMBO_LIST = [
  {
    id: "1",
    name: "combo1",
    price: 2000,
    point: 1,
  },
  {
    id: "2",
    name: "combo2",
    price: 20000,
    point: 10,
  },
  {
    id: "3",
    name: "combo3",
    price: 50000,
    point: 25,
  },
  {
    id: "4",
    name: "combo4",
    price: 100000,
    point: 50,
  },
];

export const TABLE_MAP = {
  1: "Top 10 Model Catwalk xuất sắc",
  2: "Top 10 model Tài năng xuất sắc",
  3: "Top 5 model Toàn Năng xuất sắc",
  4: "Model được yêu thích nhất",
  5: "Model Trình diễn ấn tượng",
  6: "Model Trình diễn Phong Cách",
  7: "Model Có gương mặt khả ái",
  8: "Model Cá Tính",
  9: "Model Nhân Ái",
  10: "Model Hoàn Mỹ",
  11: "Model Trình Diễn Đẹp Nhất",
  12: "Model Triển Vọng",
  13: "Model Có vẻ đẹp Á Đông",
  14: "Model Brand",
  15: "Model Truyền Cảm Hứng",
  16: "Model Chuyên Nghiệp",
  17: "Model Teen Xuất Sắc",
  18: "Model Nhí Xuất Sắc",
  19: "Model Có Gương Mặt Đẹp Nhất",
};

// export const COMBO_LIST = [
//   {
//     id: "1",
//     combo: "50 điểm",
//     priceDisplay: "20.000 đ",
//     price: 20000,
//     point: 50,
//   },
//   {
//     id: "2",
//     combo: "150 điểm",
//     priceDisplay: "50.000 đ",
//     price: 50000,
//     point: 150,
//   },
//   {
//     id: "3",
//     combo: "450 điểm",
//     priceDisplay: "100.000 đ",
//     price: 100000,
//     point: 450,
//   },
//   {
//     id: "4",
//     combo: "2500 điểm",
//     priceDisplay: "200.000 đ",
//     price: 200000,
//     point: 2500,
//   },
//   {
//     id: "5",
//     combo: "5000 điểm",
//     priceDisplay: "300.000 đ",
//     price: 300000,
//     point: 5000,
//   },
// ];
